// import { yupResolver } from '@hookform/resolvers/yup';
// import CloseIcon from '@mui/icons-material/Close';
// import {
//   Alert,
//   Autocomplete,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaCheckCircle,
//   FaClock,
//   FaFileAlt,
//   FaLock,
//   FaMapMarkerAlt,
//   FaSignature,
//   FaUndo,
//   FaUser
// } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { fetchParticipantsList } from 'slices/HomeTilesSlices';
// import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
// import { RestrictivePractices } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
// import {
//   clearRestrictivePracticesIncidentState,
//   RestrictivePracticesFollowUpFormData,
//   RestrictivePracticesFormData,
//   submitRestrictivePracticesIncident
// } from 'slices/NdisSlices/reportAllForms/restrictivePracticesIncidentSlice';
// import * as yup from 'yup';




// // Section-specific validation schemas
// const generalInfoSchema = yup
//   .object({
//     date: yup.string().required('Date of incident is required'),
//     time: yup.string().required('Time of incident is required'),
//     location: yup.string().required('Location is required'),
//     client_name: yup.string().required('Client name is required'),
//     support_worker_name: yup.string().required('Support worker name is required')
//   })
//   .required();

// const restrictivePracticeSchema = yup
//   .object({
//     type_of_practice: yup.string().required('Type of restrictive practice is required'),
//     reason_for_use: yup.string().required('Reason for use is required'),
//     approved_in_plan: yup.string().required('Please specify if practice was approved'),
//     description: yup.string().required('Incident description is required'),
//     immediate_actions: yup.string().required('Actions taken are required'),
//     recommendations: yup.string().required('Recommendations are required'),
//     photo: yup.mixed<File>().optional().default(undefined)
//   })
//   .required();

// const supportWorkerSchema = yup
//   .object({
//     support_worker_name: yup.string().required('Support worker name is required'),
//     support_worker_signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().nullable(),
//     reported_to_management: yup.string().required('Please specify if reported to management'),
//     client_email: yup.string().nullable(),
//     client_name: yup.string().nullable().default(''),
//     support_worker_name: yup.string().nullable().default('')
//   })
//   .required() as yup.ObjectSchema<RestrictivePracticesFollowUpFormData>;

// // Combined schema for main form submission
// const mainSchema: yup.ObjectSchema<RestrictivePracticesFormData> = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().required('Date of incident is required'),
//     time: yup.string().required('Time of incident is required'),
//     location: yup.string().required('Location is required'),
//     client_name: yup.string().required('Client name is required'),
//     support_worker_name: yup.string().required('Support worker name is required'),
//     type_of_practice: yup.string().required('Type of restrictive practice is required'),
//     reason_for_use: yup.string().required('Reason for use is required'),
//     approved_in_plan: yup.string().required('Please specify if practice was approved'),
//     description: yup.string().required('Incident description is required'),
//     immediate_actions: yup.string().required('Actions taken are required'),
//     reported_to_management: yup.string().optional().default(''),
//     recommendations: yup.string().required('Recommendations are required'),
//     support_worker_signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// interface StaffMember {
//   name: string;
//   email: string;
// }

// interface Client {
//   label: string;
//   id: number;
//   email: string;
// }

// interface UserDetails {
//   name: string;
//   email: string;
//   role: { role_id: string }[];
// }

// interface Props {
//   initialData?: RestrictivePractices;
//   onClose?: () => void;
// }

// const RestrictivePracticesReportForm: React.FC<Props> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector(
//     (state) => state.restrictivePracticesIncident
//   );
//   const selectedProjectId = useTypedSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useTypedSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const participantsList = useTypedSelector(
//     (state: RootState) => state?.homeTilesServices?.participants
//   ) || { participants_list: [] };
//   const supportWorkers = useTypedSelector((state: RootState) =>
//     (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
//       name: worker.name,
//       email: worker.email || ''
//     }))
//   ) as StaffMember[];
//   const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);
//   const [previewImage, setPreviewImage] = useState<string | null>(null);
//   const [clientsError, setClientsError] = useState<string | null>(null);
//   const [staffError, setStaffError] = useState<string | null>(null);
//   const [isClientsLoading, setIsClientsLoading] = useState(false);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Local storage data
//   const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//     label?: string;
//     id?: number;
//     email?: string;
//   };
//   const loginInfo = localStorage.getItem('user-details');
//   const userDetails: UserDetails | null = loginInfo ? JSON.parse(loginInfo) : null;

//   // Prepare clients list
//   const clientsList = useMemo(() => {
//     const list =
//       participantsList.participants_list?.map(
//         (participant: { name: string; email: string }, index: number) => ({
//           label: participant.name || `Client ${index + 1}`,
//           id: index + 1,
//           email: participant.email
//         })
//       ) || [];
//     if (
//       selectedClient?.label &&
//       selectedClient?.email &&
//       !list.some((client) => client.label === selectedClient.label)
//     ) {
//       list.push({
//         label: selectedClient.label,
//         id: selectedClient.id || list.length + 1,
//         email: selectedClient.email
//       });
//     }
//     return list;
//   }, [participantsList.participants_list, selectedClient]);

//   // Fetch participants
//   useEffect(() => {
//     if (
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       setIsClientsLoading(true);
//       dispatch(
//         fetchParticipantsList({
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           nested_component_id: location.pathname,
//           email: userDetails.email,
//           roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//           client_name: ''
//         })
//       )
//         .then(() => {
//           setIsClientsLoading(false);
//         })
//         .catch((error: unknown) => {
//           setIsClientsLoading(false);
//           setClientsError('Failed to load clients. Please try again later.');
//         });
//     } else {
//       setIsClientsLoading(false);
//     }
//   }, []);

//   // Fetch support workers
//   useEffect(() => {
//     if (
//       selectedClient?.label &&
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
//       const payload = {
//         group_id: selectedProjectId,
//         service_name_id: selectedServiceTitle.replace(' ', '_'),
//         nested_component_id: 'Staff_List',
//         email_loggedIn_userEmail: userDetails.email,
//         roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//         client_name: selectedClient.label?.replace(' ', '_') || '',
//         approved_user: approvedUser,
//         curr_loggIn_userRoles: userDetails?.name || ''
//       };

//       dispatch(fetchStaffByRoles(payload));
//     }
//   }, []);

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || '';
//   const incidentId = searchParams.get('id') || initialData?.id || undefined;

//   // Strictly enforce form visibility based on URL
//   const isMainFormRoute = location.pathname === '/restrictive-PracticesReport';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

//   // Check if Follow-Up form is already filled
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   useEffect(() => {
//     if (isFollowUpRoute && initialData) {
//       const isFilled =
//         initialData.reported_to_management !== undefined &&
//         initialData.reported_to_management !== null &&
//         initialData.reported_to_management !== '';
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isFollowUpRoute]);

//   // Main form
//   const defaultDateTime = new Date().toISOString().split('T')[0];
//   const mainForm = useForm<RestrictivePracticesFormData>({
//     resolver: yupResolver(mainSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || defaultDateTime,
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
//       type_of_practice: initialData?.type_of_practice || '',
//       reason_for_use: initialData?.reason_for_use || '',
//       approved_in_plan: initialData?.approved_in_plan || '',
//       description: initialData?.description || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       reported_to_management: initialData?.reported_to_management || '',
//       recommendations: initialData?.recommendations || '',
//       support_worker_signature: initialData?.support_worker_signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || ''
//     }
//   });

//   // Follow-up form
//   const followUpForm = useForm<RestrictivePracticesFollowUpFormData>({
//     resolver: yupResolver(followUpSchema),
//     defaultValues: {
//       id: incidentId || initialData?.id || '',
//       reported_to_management: initialData?.reported_to_management || '',
//       client_email: selectedClient?.email || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
//       photo: undefined
//     }
//   });

//   // Section-specific validation state
//   const [generalInfoErrors, setGeneralInfoErrors] = useState<string[]>([]);
//   const [restrictivePracticeErrors, setRestrictivePracticeErrors] = useState<string[]>([]);
//   const [supportWorkerErrors, setSupportWorkerErrors] = useState<string[]>([]);

//   // Validate individual sections for main form
//   const validateSection = async (
//     schema: yup.AnyObjectSchema,
//     data: Partial<RestrictivePracticesFormData>
//   ) => {
//     try {
//       await schema.validate(data, { abortEarly: false });
//       return [];
//     } catch (err) {
//       if (err instanceof yup.ValidationError) {
//         return err.inner.map((e) => e.message);
//       }
//       return ['Unknown validation error'];
//     }
//   };

//   // Handle image change
//   const handleImageChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | undefined) => void
//   ) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       const file = files[0];
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPreviewImage(null);
//       onChange(undefined);
//     }
//   };

//   // Remove image
//   const handleRemoveImage = () => {
//     setPreviewImage(null);
//     if (isMainFormRoute) {
//       mainForm.setValue('photo', undefined, { shouldValidate: true });
//     }
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   // Submit handler for main form
//   const onSubmitMain = async (data: RestrictivePracticesFormData) => {
//     try {
//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';
//       if (!client_email) {
//         mainForm.setError('client_email', {
//           type: 'manual',
//           message: 'Client email is required for submission'
//         });
//         return;
//       }

//       const generalInfoData = {
//         date: data.date,
//         time: data.time,
//         location: data.location,
//         client_name: data.client_name,
//         support_worker_name: data.support_worker_name
//       };
//       const restrictivePracticeData = {
//         type_of_practice: data.type_of_practice,
//         reason_for_use: data.reason_for_use,
//         approved_in_plan: data.approved_in_plan,
//         description: data.description,
//         immediate_actions: data.immediate_actions,
//         recommendations: data.recommendations,
//         photo: data.photo
//       };
//       const supportWorkerData = {
//         support_worker_name: data.support_worker_name,
//         support_worker_signature: data.support_worker_signature,
//         date_completed: data.date_completed
//       };

//       const [generalErrors, restrictiveErrors, supportErrors] = await Promise.all([
//         validateSection(generalInfoSchema, generalInfoData),
//         validateSection(restrictivePracticeSchema, restrictivePracticeData),
//         validateSection(supportWorkerSchema, supportWorkerData)
//       ]);

//       setGeneralInfoErrors(generalErrors);
//       setRestrictivePracticeErrors(restrictiveErrors);
//       setSupportWorkerErrors(supportErrors);

//       if (generalErrors.length > 0 || restrictiveErrors.length > 0 || supportErrors.length > 0) {
//         mainForm.setError('root', {
//           type: 'manual',
//           message: 'Please fix validation errors in the form sections.'
//         });
//         return;
//       }

//       const payload: RestrictivePracticesFormData = {
//         ...data,
//         client_email
//       };

//       await dispatch(submitRestrictivePracticesIncident(payload)).unwrap();
//       mainForm.reset();
//       setPreviewImage(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setGeneralInfoErrors([]);
//       setRestrictivePracticeErrors([]);
//       setSupportWorkerErrors([]);
//       setTimeout(() => dispatch(clearRestrictivePracticesIncidentState()), 5000);
//     } catch (err) {
//       console.error('Main form submission error:', err);
//       mainForm.setError('root', {
//         type: 'manual',
//         message: 'Failed to submit form. Please check all fields and try again.'
//       });
//     }
//   };

//   // Submit handler for follow-up form
//   const onSubmitFollowUp = async (data: RestrictivePracticesFollowUpFormData) => {
//     try {
//       if (!incidentId) {
//         followUpForm.setError('root', {
//           type: 'manual',
//           message: 'Incident ID is required for follow-up submission'
//         });
//         return;
//       }

//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';
//       if (!client_email) {
//         followUpForm.setError('client_email', {
//           type: 'manual',
//           message: 'Client email is required for submission'
//         });
//         return;
//       }

//       // Merge initialData with follow-up form data to preserve existing fields
//       const payload: RestrictivePracticesFormData = {
//         id: incidentId,
//         date: initialData?.date || '',
//         time: initialData?.time || '',
//         location: initialData?.location || '',
//         client_name: initialData?.client_name || data.client_name || '',
//         support_worker_name: initialData?.support_worker_name || data.support_worker_name || '',
//         type_of_practice: initialData?.type_of_practice || '',
//         reason_for_use: initialData?.reason_for_use || '',
//         approved_in_plan: initialData?.approved_in_plan || '',
//         description: initialData?.description || '',
//         immediate_actions: initialData?.immediate_actions || '',
//         reported_to_management: data.reported_to_management,
//         recommendations: initialData?.recommendations || '',
//         support_worker_signature: initialData?.support_worker_signature || '',
//         date_completed: initialData?.date_completed || '',
//         photo: initialData?.photo || '',
//         client_email
//       };

//       await dispatch(submitRestrictivePracticesIncident(payload)).unwrap();
//       followUpForm.reset();
//       setTimeout(() => dispatch(clearRestrictivePracticesIncidentState()), 5000);
//       if (onClose) {
//         onClose();
//       }
//     } catch (err) {
//       console.error('Follow-up form submission error:', err);
//       followUpForm.setError('root', {
//         type: 'manual',
//         message: 'Failed to submit follow-up form. Please check all fields and try again.'
//       });
//     }
//   };

//   // Reset handler for main form
//   const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     mainForm.reset();
//     mainForm.clearErrors();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     setGeneralInfoErrors([]);
//     setRestrictivePracticeErrors([]);
//     setSupportWorkerErrors([]);
//     dispatch(clearRestrictivePracticesIncidentState());
//   };

//   // Reset handler for follow-up form
//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     followUpForm.clearErrors();
//     dispatch(clearRestrictivePracticesIncidentState());
//   };

//   // Log validation errors for debugging
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     if (isMainFormRoute && Object.keys(mainForm.formState.errors).length > 0) {
//       console.log('Main form validation errors:', mainForm.formState.errors);
//     }
//     if (isFollowUpRoute && Object.keys(followUpForm.formState.errors).length > 0) {
//       console.log('Follow-up form validation errors:', followUpForm.formState.errors);
//     }
//   }, [mainForm.formState.errors, followUpForm.formState.errors, isMainFormRoute, isFollowUpRoute]);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.warning.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.warning.contrastText
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isMainFormRoute
//                 ? 'Restrictive Practices Report'
//                 : 'Restrictive Practices Follow-Up Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isMainFormRoute
//               ? 'To document any use of restrictive practices'
//               : 'For follow-up actions on restrictive practices incidents'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearRestrictivePracticesIncidentState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearRestrictivePracticesIncidentState())}
//           >
//             {error}
//           </Alert>
//         )}
//         {clientsError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
//             {clientsError}
//           </Alert>
//         )}
//         {staffError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
//             {staffError}
//           </Alert>
//         )}
//         {(mainForm.formState.errors.root || followUpForm.formState.errors.root) && (
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {mainForm.formState.errors.root?.message ||
//               followUpForm.formState.errors.root?.message ||
//               'Please check all fields and try again.'}
//           </Alert>
//         )}
//         {isFollowUpRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This follow-up form has already been filled.
//           </Alert>
//         )}

//         {isMainFormRoute && (
//           <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />
//               {generalInfoErrors.length > 0 && (
//                 <Alert severity="error" sx={{ mb: 2 }}>
//                   <Typography variant="caption">General Information Errors:</Typography>
//                   <ul>
//                     {generalInfoErrors.map((err, index) => (
//                       <li key={index}>{err}</li>
//                     ))}
//                   </ul>
//                 </Alert>
//               )}
//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Incident"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date}
//                         helperText={mainForm.formState.errors.date?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="time"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Time of Incident"
//                         type="time"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaClock size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.time}
//                         helperText={mainForm.formState.errors.time?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="location"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Location"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaMapMarkerAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.location}
//                         helperText={mainForm.formState.errors.location?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="client_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={clientsList}
//                           getOptionLabel={(option) => option.label || ''}
//                           value={clientsList.find((client) => client.label === field.value) || null}
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.label : '');
//                           }}
//                           loading={isClientsLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Client's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {isClientsLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!mainForm.formState.errors.client_name}
//                               helperText={mainForm.formState.errors.client_name?.message}
//                             />
//                           )}
//                           noOptionsText="No clients found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={supportWorkers}
//                           getOptionLabel={(option) => option.name || ''}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.name : '');
//                           }}
//                           loading={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {staffLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!mainForm.formState.errors.support_worker_name}
//                               helperText={mainForm.formState.errors.support_worker_name?.message}
//                             />
//                           )}
//                           noOptionsText="No support workers found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Restrictive Practice Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaLock
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Restrictive Practice Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />
//               {restrictivePracticeErrors.length > 0 && (
//                 <Alert severity="error" sx={{ mb: 2 }}>
//                   <Typography variant="caption">Restrictive Practice Errors:</Typography>
//                   <ul>
//                     {restrictivePracticeErrors.map((err, index) => (
//                       <li key={index}>{err}</li>
//                     ))}
//                   </ul>
//                 </Alert>
//               )}
//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Type of Restrictive Practice Used
//                     </Typography>
//                     <Controller
//                       name="type_of_practice"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Physical"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Physical
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Chemical"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Chemical (medication)
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Environmental Seclusion"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Environmental Seclusion (locked in a room/place)
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Mechanical"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Mechanical
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.type_of_practice && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.type_of_practice.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="reason_for_use"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Reason for Use"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.reason_for_use}
//                         helperText={mainForm.formState.errors.reason_for_use?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Practice Approved in the Client’s Care Plan?
//                     </Typography>
//                     <Controller
//                       name="approved_in_plan"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.approved_in_plan && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.approved_in_plan.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.description}
//                         helperText={mainForm.formState.errors.description?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="immediate_actions"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Immediate Actions Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.immediate_actions}
//                         helperText={mainForm.formState.errors.immediate_actions?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="recommendations"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Recommendations"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.recommendations}
//                         helperText={mainForm.formState.errors.recommendations?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={mainForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={fileInputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handleImageChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!mainForm.formState.errors.photo}
//                           helperText={mainForm.formState.errors.photo?.message}
//                         />
//                         {previewImage && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={previewImage}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemoveImage}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <CloseIcon fontSize="small" />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {previewImage && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={previewImage}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemoveImage}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Support Worker Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Support Worker Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />
//               {supportWorkerErrors.length > 0 && (
//                 <Alert severity="error" sx={{ mb: 2 }}>
//                   <Typography variant="caption">Support Worker Errors:</Typography>
//                   <ul>
//                     {supportWorkerErrors.map((err, index) => (
//                       <li key={index}>{err}</li>
//                     ))}
//                   </ul>
//                 </Alert>
//               )}
//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={supportWorkers}
//                           getOptionLabel={(option) => option.name || ''}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.name : '');
//                           }}
//                           loading={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {staffLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!mainForm.formState.errors.support_worker_name}
//                               helperText={mainForm.formState.errors.support_worker_name?.message}
//                             />
//                           )}
//                           noOptionsText="No support workers found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_signature"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaSignature size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.support_worker_signature}
//                         helperText={mainForm.formState.errors.support_worker_signature?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_completed"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_completed}
//                         helperText={mainForm.formState.errors.date_completed?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons for Main Form */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetMain}
//                 disabled={!mainForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Report'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* General Information for Follow-Up */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />
//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="client_name"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={clientsList}
//                           getOptionLabel={(option) => option.label || ''}
//                           value={clientsList.find((client) => client.label === field.value) || null}
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.label : '');
//                           }}
//                           loading={isClientsLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Client's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {isClientsLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!followUpForm.formState.errors.client_name}
//                               helperText={followUpForm.formState.errors.client_name?.message}
//                             />
//                           )}
//                           noOptionsText="No clients found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={supportWorkers}
//                           getOptionLabel={(option) => option.name || ''}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.name : '');
//                           }}
//                           loading={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {staffLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!followUpForm.formState.errors.support_worker_name}
//                               helperText={
//                                 followUpForm.formState.errors.support_worker_name?.message
//                               }
//                             />
//                           )}
//                           noOptionsText="No support workers found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />
//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Incident Reported to Management?
//                     </Typography>
//                     <Controller
//                       name="reported_to_management"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.reported_to_management && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.reported_to_management.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons for Follow-Up Form */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !incidentId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default RestrictivePracticesReportForm;

import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaCheckCircle,
  FaClock,
  FaFileAlt,
  FaLock,
  FaMapMarkerAlt,
  FaSignature,
  FaUndo,
  FaUser
} from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchParticipantsList } from 'slices/HomeTilesSlices';
import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
import { RestrictivePractices } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
import {
  clearRestrictivePracticesIncidentState,
  RestrictivePracticesFollowUpFormData,
  RestrictivePracticesFormData,
  submitRestrictivePracticesIncident
} from 'slices/NdisSlices/reportAllForms/restrictivePracticesIncidentSlice';
import * as yup from 'yup';

// Section-specific validation schemas
const generalInfoSchema = yup
  .object({
    date: yup.string().required('Date of incident is required'),
    time: yup.string().required('Time of incident is required'),
    location: yup.string().required('Location is required'),
    client_name: yup.string().required('Client name is required'),
    support_worker_name: yup.string().required('Support worker name is required')
  })
  .required();

const restrictivePracticeSchema = yup
  .object({
    type_of_practice: yup.string().required('Type of restrictive practice is required'),
    reason_for_use: yup.string().required('Reason for use is required'),
    approved_in_plan: yup.string().required('Please specify if practice was approved'),
    description: yup.string().required('Incident description is required'),
    immediate_actions: yup.string().required('Actions taken are required'),
    recommendations: yup.string().required('Recommendations are required'),
    photo: yup.mixed<File>().optional().default(undefined)
  })
  .required();

const supportWorkerSchema = yup
  .object({
    support_worker_name: yup.string().required('Support worker name is required'),
    support_worker_signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required')
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().nullable(),
    reported_to_management: yup.string().required('Please specify if reported to management'),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
      .required('Please specify if the incident is resolved'),
    client_email: yup.string().nullable(),
    client_name: yup.string().nullable().default(''),
    support_worker_name: yup.string().nullable().default('')
  })
  .required() as yup.ObjectSchema<RestrictivePracticesFollowUpFormData>;

// Combined schema for main form submission
const mainSchema: yup.ObjectSchema<RestrictivePracticesFormData> = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().required('Date of incident is required'),
    time: yup.string().required('Time of incident is required'),
    location: yup.string().required('Location is required'),
    client_name: yup.string().required('Client name is required'),
    support_worker_name: yup.string().required('Support worker name is required'),
    type_of_practice: yup.string().required('Type of restrictive practice is required'),
    reason_for_use: yup.string().required('Reason for use is required'),
    approved_in_plan: yup.string().required('Please specify if practice was approved'),
    description: yup.string().required('Incident description is required'),
    immediate_actions: yup.string().required('Actions taken are required'),
    reported_to_management: yup.string().optional().default(''),
    resolved: yup.string().optional().default(''),
    recommendations: yup.string().required('Recommendations are required'),
    support_worker_signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

interface StaffMember {
  name: string;
  email: string;
}

interface Client {
  label: string;
  id: number;
  email: string;
}

interface UserDetails {
  name: string;
  email: string;
  role: { role_id: string }[];
}

interface Props {
  initialData?: RestrictivePractices;
  onClose?: () => void;
}

const RestrictivePracticesReportForm: React.FC<Props> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector(
    (state) => state.restrictivePracticesIncident
  );
  const selectedProjectId = useTypedSelector(
    (state: RootState) => state.homeTilesServices.selectedProjectId
  );
  const selectedServiceTitle = useTypedSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle
  );
  const participantsList = useTypedSelector(
    (state: RootState) => state?.homeTilesServices?.participants
  ) || { participants_list: [] };
  const supportWorkers = useTypedSelector((state: RootState) =>
    (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
      name: worker.name,
      email: worker.email || ''
    }))
  ) as StaffMember[];
  const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [clientsError, setClientsError] = useState<string | null>(null);
  const [staffError, setStaffError] = useState<string | null>(null);
  const [isClientsLoading, setIsClientsLoading] = useState(false);
  const [alreadyFilled, setAlreadyFilled] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    label?: string;
    id?: number;
    email?: string;
  };
  const loginInfo = localStorage.getItem('user-details');
  const userDetails: UserDetails | null = loginInfo ? JSON.parse(loginInfo) : null;

  // Prepare clients list
  const clientsList = useMemo(() => {
    const list =
      participantsList.participants_list?.map(
        (participant: { name: string; email: string }, index: number) => ({
          label: participant.name || `Client ${index + 1}`,
          id: index + 1,
          email: participant.email
        })
      ) || [];
    if (
      selectedClient?.label &&
      selectedClient?.email &&
      !list.some((client) => client.label === selectedClient.label)
    ) {
      list.push({
        label: selectedClient.label,
        id: selectedClient.id || list.length + 1,
        email: selectedClient.email
      });
    }
    return list;
  }, [participantsList.participants_list, selectedClient]);

  // Fetch participants
  useEffect(() => {
    if (
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      setIsClientsLoading(true);
      dispatch(
        fetchParticipantsList({
          group_id: selectedProjectId || '',
          service_name_id: selectedServiceTitle || '',
          nested_component_id: location.pathname,
          email: userDetails.email,
          roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
          client_name: ''
        })
      )
        .then(() => {
          setIsClientsLoading(false);
        })
        .catch((error: unknown) => {
          setIsClientsLoading(false);
          setClientsError('Failed to load clients. Please try again later.');
        });
    } else {
      setIsClientsLoading(false);
    }
  }, []);

  // Fetch support workers
  useEffect(() => {
    if (
      selectedClient?.label &&
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
      const payload = {
        group_id: selectedProjectId,
        service_name_id: selectedServiceTitle.replace(' ', '_'),
        nested_component_id: 'Staff_List',
        email_loggedIn_userEmail: userDetails.email,
        roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
        client_name: selectedClient.label?.replace(' ', '_') || '',
        approved_user: approvedUser,
        curr_loggIn_userRoles: userDetails?.name || ''
      };

      dispatch(fetchStaffByRoles(payload));
    }
  }, []);

  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || '';
  const incidentId = searchParams.get('id') || initialData?.id || undefined;

  // Strictly enforce form visibility based on URL
  const isMainFormRoute = location.pathname === '/restrictive-PracticesReport';
  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

  // Check if Follow-Up form is already filled
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      console.log('initialData', initialData);
      const isResolved = String(initialData?.resolved).toLowerCase() === 'yes';
      setAlreadyFilled(isResolved);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Main form
  const defaultDateTime = new Date().toISOString().split('T')[0];
  const mainForm = useForm<RestrictivePracticesFormData>({
    resolver: yupResolver(mainSchema),
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || defaultDateTime,
      time: initialData?.time || '',
      location: initialData?.location || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
      type_of_practice: initialData?.type_of_practice || '',
      reason_for_use: initialData?.reason_for_use || '',
      approved_in_plan: initialData?.approved_in_plan || '',
      description: initialData?.description || '',
      immediate_actions: initialData?.immediate_actions || '',
      reported_to_management: initialData?.reported_to_management || '',
      resolved: initialData?.resolved || '',
      recommendations: initialData?.recommendations || '',
      support_worker_signature: initialData?.support_worker_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || ''
    }
  });

  // Follow-up form
  const followUpForm = useForm<RestrictivePracticesFollowUpFormData>({
    resolver: yupResolver(followUpSchema),
    defaultValues: {
      id: incidentId || initialData?.id || '',
      reported_to_management: initialData?.reported_to_management || '',
      resolved: initialData?.resolved || '',
      client_email: selectedClient?.email || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
      photo: undefined
    }
  });

  // Section-specific validation state
  const [generalInfoErrors, setGeneralInfoErrors] = useState<string[]>([]);
  const [restrictivePracticeErrors, setRestrictivePracticeErrors] = useState<string[]>([]);
  const [supportWorkerErrors, setSupportWorkerErrors] = useState<string[]>([]);

  // Validate individual sections for main form
  const validateSection = async (
    schema: yup.AnyObjectSchema,
    data: Partial<RestrictivePracticesFormData>
  ) => {
    try {
      await schema.validate(data, { abortEarly: false });
      return [];
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        return err.inner.map((e) => e.message);
      }
      return ['Unknown validation error'];
    }
  };

  // Handle image change
  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | undefined) => void
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      onChange(undefined);
    }
  };

  // Remove image
  const handleRemoveImage = () => {
    setPreviewImage(null);
    if (isMainFormRoute) {
      mainForm.setValue('photo', undefined, { shouldValidate: true });
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Submit handler for main form
  const onSubmitMain = async (data: RestrictivePracticesFormData) => {
    try {
      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';
      if (!client_email) {
        mainForm.setError('client_email', {
          type: 'manual',
          message: 'Client email is required for submission'
        });
        return;
      }

      const generalInfoData = {
        date: data.date,
        time: data.time,
        location: data.location,
        client_name: data.client_name,
        support_worker_name: data.support_worker_name
      };
      const restrictivePracticeData = {
        type_of_practice: data.type_of_practice,
        reason_for_use: data.reason_for_use,
        approved_in_plan: data.approved_in_plan,
        description: data.description,
        immediate_actions: data.immediate_actions,
        recommendations: data.recommendations,
        photo: data.photo
      };
      const supportWorkerData = {
        support_worker_name: data.support_worker_name,
        support_worker_signature: data.support_worker_signature,
        date_completed: data.date_completed
      };

      const [generalErrors, restrictiveErrors, supportErrors] = await Promise.all([
        validateSection(generalInfoSchema, generalInfoData),
        validateSection(restrictivePracticeSchema, restrictivePracticeData),
        validateSection(supportWorkerSchema, supportWorkerData)
      ]);

      setGeneralInfoErrors(generalErrors);
      setRestrictivePracticeErrors(restrictiveErrors);
      setSupportWorkerErrors(supportErrors);

      if (generalErrors.length > 0 || restrictiveErrors.length > 0 || supportErrors.length > 0) {
        mainForm.setError('root', {
          type: 'manual',
          message: 'Please fix validation errors in the form sections.'
        });
        return;
      }

      const payload: RestrictivePracticesFormData = {
        ...data,
        client_email
      };

      await dispatch(submitRestrictivePracticesIncident(payload)).unwrap();
      mainForm.reset();
      setPreviewImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setGeneralInfoErrors([]);
      setRestrictivePracticeErrors([]);
      setSupportWorkerErrors([]);
      setTimeout(() => dispatch(clearRestrictivePracticesIncidentState()), 5000);
    } catch (err) {
      console.error('Main form submission error:', err);
      mainForm.setError('root', {
        type: 'manual',
        message: 'Failed to submit form. Please check all fields and try again.'
      });
    }
  };

  // Submit handler for follow-up form
  const onSubmitFollowUp = async (data: RestrictivePracticesFollowUpFormData) => {
    try {
      if (!incidentId) {
        followUpForm.setError('root', {
          type: 'manual',
          message: 'Incident ID is required for follow-up submission'
        });
        return;
      }

      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';
      if (!client_email) {
        followUpForm.setError('client_email', {
          type: 'manual',
          message: 'Client email is required for submission'
        });
        return;
      }

      // Merge initialData with follow-up form data to preserve existing fields
      const payload: RestrictivePracticesFormData = {
        id: incidentId,
        date: initialData?.date || '',
        time: initialData?.time || '',
        location: initialData?.location || '',
        client_name: initialData?.client_name || data.client_name || '',
        support_worker_name: initialData?.support_worker_name || data.support_worker_name || '',
        type_of_practice: initialData?.type_of_practice || '',
        reason_for_use: initialData?.reason_for_use || '',
        approved_in_plan: initialData?.approved_in_plan || '',
        description: initialData?.description || '',
        immediate_actions: initialData?.immediate_actions || '',
        reported_to_management: data.reported_to_management,
        resolved: data.resolved,
        recommendations: initialData?.recommendations || '',
        support_worker_signature: initialData?.support_worker_signature || '',
        date_completed: initialData?.date_completed || '',
        photo: initialData?.photo || '',
        client_email
      };

      await dispatch(submitRestrictivePracticesIncident(payload)).unwrap();
      followUpForm.reset();
      setTimeout(() => dispatch(clearRestrictivePracticesIncidentState()), 5000);
      if (onClose) {
        onClose();
      }
    } catch (err) {
      console.error('Follow-up form submission error:', err);
      followUpForm.setError('root', {
        type: 'manual',
        message: 'Failed to submit follow-up form. Please check all fields and try again.'
      });
    }
  };

  // Reset handler for main form
  const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mainForm.reset();
    mainForm.clearErrors();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setGeneralInfoErrors([]);
    setRestrictivePracticeErrors([]);
    setSupportWorkerErrors([]);
    dispatch(clearRestrictivePracticesIncidentState());
  };

  // Reset handler for follow-up form
  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    followUpForm.clearErrors();
    dispatch(clearRestrictivePracticesIncidentState());
  };

  // Log validation errors for debugging
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (isMainFormRoute && Object.keys(mainForm.formState.errors).length > 0) {
      console.log('Main form validation errors:', mainForm.formState.errors);
    }
    if (isFollowUpRoute && Object.keys(followUpForm.formState.errors).length > 0) {
      console.log('Follow-up form validation errors:', followUpForm.formState.errors);
    }
  }, [mainForm.formState.errors, followUpForm.formState.errors, isMainFormRoute, isFollowUpRoute]);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.warning.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.warning.contrastText
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isMainFormRoute
                ? 'Restrictive Practices Report'
                : 'Restrictive Practices Follow-Up Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isMainFormRoute
              ? 'To document any use of restrictive practices'
              : 'For follow-up actions on restrictive practices incidents'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearRestrictivePracticesIncidentState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearRestrictivePracticesIncidentState())}
          >
            {error}
          </Alert>
        )}
        {clientsError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
            {clientsError}
          </Alert>
        )}
        {staffError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
            {staffError}
          </Alert>
        )}
        {(mainForm.formState.errors.root || followUpForm.formState.errors.root) && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {mainForm.formState.errors.root?.message ||
              followUpForm.formState.errors.root?.message ||
              'Please check all fields and try again.'}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This follow-up form has already been filled.
          </Alert>
        )}

        {isMainFormRoute && (
          <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />
              {generalInfoErrors.length > 0 && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  <Typography variant="caption">General Information Errors:</Typography>
                  <ul>
                    {generalInfoErrors.map((err, index) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                </Alert>
              )}
              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Incident"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date}
                        helperText={mainForm.formState.errors.date?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="time"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Time of Incident"
                        type="time"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaClock size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.time}
                        helperText={mainForm.formState.errors.time?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="location"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Location"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaMapMarkerAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.location}
                        helperText={mainForm.formState.errors.location?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="client_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={clientsList}
                          getOptionLabel={(option) => option.label || ''}
                          value={clientsList.find((client) => client.label === field.value) || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.label : '');
                          }}
                          loading={isClientsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Client's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {isClientsLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!mainForm.formState.errors.client_name}
                              helperText={mainForm.formState.errors.client_name?.message}
                            />
                          )}
                          noOptionsText="No clients found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={supportWorkers}
                          getOptionLabel={(option) => option.name || ''}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.name : '');
                          }}
                          loading={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {staffLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!mainForm.formState.errors.support_worker_name}
                              helperText={mainForm.formState.errors.support_worker_name?.message}
                            />
                          )}
                          noOptionsText="No support workers found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Restrictive Practice Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaLock
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Restrictive Practice Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />
              {restrictivePracticeErrors.length > 0 && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  <Typography variant="caption">Restrictive Practice Errors:</Typography>
                  <ul>
                    {restrictivePracticeErrors.map((err, index) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                </Alert>
              )}
              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Type of Restrictive Practice Used
                    </Typography>
                    <Controller
                      name="type_of_practice"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2,
                            flexWrap: 'wrap'
                          }}
                        >
                          <FormControlLabel
                            value="Physical"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Physical
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Chemical"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Chemical (medication)
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Environmental Seclusion"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Environmental Seclusion (locked in a room/place)
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Mechanical"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Mechanical
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.type_of_practice && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.type_of_practice.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="reason_for_use"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Reason for Use"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.reason_for_use}
                        helperText={mainForm.formState.errors.reason_for_use?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Practice Approved in the Client’s Care Plan?
                    </Typography>
                    <Controller
                      name="approved_in_plan"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.approved_in_plan && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.approved_in_plan.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.description}
                        helperText={mainForm.formState.errors.description?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="immediate_actions"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Immediate Actions Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.immediate_actions}
                        helperText={mainForm.formState.errors.immediate_actions?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="recommendations"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Recommendations"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.recommendations}
                        helperText={mainForm.formState.errors.recommendations?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={mainForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={fileInputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleImageChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!mainForm.formState.errors.photo}
                          helperText={mainForm.formState.errors.photo?.message}
                        />
                        {previewImage && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={previewImage}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemoveImage}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {previewImage && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={previewImage}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Support Worker Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Support Worker Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />
              {supportWorkerErrors.length > 0 && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  <Typography variant="caption">Support Worker Errors:</Typography>
                  <ul>
                    {supportWorkerErrors.map((err, index) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                </Alert>
              )}
              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={supportWorkers}
                          getOptionLabel={(option) => option.name || ''}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.name : '');
                          }}
                          loading={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {staffLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!mainForm.formState.errors.support_worker_name}
                              helperText={mainForm.formState.errors.support_worker_name?.message}
                            />
                          )}
                          noOptionsText="No support workers found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_signature"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaSignature size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.support_worker_signature}
                        helperText={mainForm.formState.errors.support_worker_signature?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="date_completed"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_completed}
                        helperText={mainForm.formState.errors.date_completed?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons for Main Form */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetMain}
                disabled={!mainForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Report'}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* General Information for Follow-Up */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />
              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="client_name"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={clientsList}
                          getOptionLabel={(option) => option.label || ''}
                          value={clientsList.find((client) => client.label === field.value) || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.label : '');
                          }}
                          loading={isClientsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Client's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {isClientsLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!followUpForm.formState.errors.client_name}
                              helperText={followUpForm.formState.errors.client_name?.message}
                            />
                          )}
                          noOptionsText="No clients found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={supportWorkers}
                          getOptionLabel={(option) => option.name || ''}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.name : '');
                          }}
                          loading={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {staffLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!followUpForm.formState.errors.support_worker_name}
                              helperText={
                                followUpForm.formState.errors.support_worker_name?.message
                              }
                            />
                          )}
                          noOptionsText="No support workers found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />
              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Incident Reported to Management?
                    </Typography>
                    <Controller
                      name="reported_to_management"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.reported_to_management && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.reported_to_management.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Incident Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons for Follow-Up Form */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetFollowUp}
                disabled={!followUpForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !incidentId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default RestrictivePracticesReportForm;
